import http from "../util/ws/wsService.js";

import EntityServise from "./entityService.js";

class RegService extends EntityServise {
  constructor() {
    super("reg");
  }

  async regById(id){
    return await http.get('/reg/' + id)
  }

  async searchRegs(
    dtStart,
    dtEnd,
    jobCode,
    jobId,
    resourceCode,
    resourceId,
    regTypeCode,
    userName,
    regFieldsArray,
    page,
    limit
  ) {
    return await http.get("integration/reg", {
      dtStart,
      dtEnd,
      jobCode,
      jobId,
      resourceCode,
      resourceId,
      regTypeCode,
      userName,
      regFieldsArray,
      page,
      limit
    });
  }
}

export default new RegService();
